var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-info__color"},[_c('color-swatch',{attrs:{"options":_vm.options,"parentAttribute":_vm.parentAttribute,"defaultSelected":_vm.defaultSelected},on:{"filterSelected":function($event){return _vm.change($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }